
import React from 'react'

const STEPS = [
  {
    id: 1,
    text: "Scegli il piano",
    selected: true,
  },
  {
    id: 2,
    text: "Inserisci i tuoi dati",
    selected: false,
  },
  {
    id: 3,
    text: "Inizia la prova",
    selected: false,
  },
];

function Wizard({ activeStep }) {
  return (
    <div className="
        w-full
        px-0
        sm:px-12
        lg:px-20
        xl:px-32
        flex
        justify-between
      "
    >
      {STEPS.map((step, index) => <Step
        key={step.id}
        {...step}
        active={index === activeStep}
        passed={activeStep > index}
      />)}
    </div>
  );
}

function Step(props) {
  const { text, id, active, passed } = props;

  return (
    <div
      className={`
      flex
      flex-col
      sm:flex-row
      items-center 
      justify-center 
      text-base
    `}
    >
      <div
        className={`
        flex
        items-center
        justify-center
        
        w-6
        h-6

        mr-2
        mb-1
        lg:mb-0

        rounded-full

        font-black
        font-display

        text-white
        text-xs
        ${active ? "bg-primary" : "bg-gray-400"}
        ${passed ? "bg-green-500" : ""}
      `}
      >
        {id}
      </div>
      <div className={passed ? "text-green-500" : undefined}>{text}</div>
    </div>
  );
}

export default Wizard
